<template>
  <div id="app">
  	<transition name="component-fade" mode="out-in">
    	<router-view/>
    </transition>
  </div>
</template>

<script>
import ConfigService from "./helpers/config";

export default {
  name: 'app',
  mounted: function() {
  	// ConfigService.init();
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  	@import "./styles/main.scss";
  	@import "./styles/responsive.scss";

  	.component-fade-enter, .component-fade-leave-to {
  		opacity: 0;
  	}

  	.component-fade-leave, .component-fade-enter-to {
  		opacity: 1;
  	}

  	.component-fade-enter-active {
	  	transition: opacity 0.5s ease-in;
	}

	.component-fade-leave-active {
		transition: opacity 0.5s ease-out;
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue